module.exports = __webpack_public_path__ + "static/media/tele1.c1c9feea.svg";